(function ($) {
  var $keys = saphaliWoocommerceLiteSettings?.keys || [];
  var $skeys = saphaliWoocommerceLiteSettings?.skeys || [];

  function normalizeMethods(methods) {
    return Object.keys(methods || {}).map(function (key) {
      return methods[key];
    });
  }

  function shippingMethodMatches(selectedMethod, methods) {
    return methods.some(function (method) {
      var methodId = String(method || "").split(":")[0];
      return selectedMethod === methodId;
    });
  }

  function corect_method_filds() {
    var selected_p_method = $('input[name="payment_method"]:checked').val();
    var selected_s_method =
      typeof $(
        'input.shipping_method:checked, input.shipping_method[type="hidden"], select.shipping_method'
      ).val() !== "undefined"
        ? $(
            'input.shipping_method:checked, input.shipping_method[type="hidden"], select.shipping_method'
          )
            .val()
            .split(":")[0]
        : "";
    var fieldKeys = Object.keys($keys).concat(Object.keys($skeys)).filter(function (key, index, keys) {
      return keys.indexOf(key) === index;
    });

    $.each(fieldKeys, function (index, fieldKey) {
      var paymentMatches =
        !Object.prototype.hasOwnProperty.call($keys, fieldKey) ||
        $.inArray(selected_p_method, normalizeMethods($keys[fieldKey])) >= 0;
      var shippingMatches =
        !Object.prototype.hasOwnProperty.call($skeys, fieldKey) ||
        shippingMethodMatches(selected_s_method, normalizeMethods($skeys[fieldKey]));

      if (paymentMatches && shippingMatches) {
        if (
          !(
            $("#billing_platelshik_is_grpl").is(":checked") &&
            (fieldKey === "billing_gruzopoluch" || fieldKey === "billing_gruzopoluch_okpo")
          )
        )
          $("#" + fieldKey + "_field").show("slow");
      } else {
        $("#" + fieldKey + "_field").hide("slow");
      }
    });
  }
  $("body").on("click", 'input[name="payment_method"]', function () {
    corect_method_filds();
  });
  $("body").on("payment_method_selected", function () {
    corect_method_filds();
  });
  $("body").on("click", "input.shipping_method", function () {
    corect_method_filds();
  });
  $("body").on("change", "select.shipping_method", function () {
    corect_method_filds();
  });
  $("body").on("updated_checkout", function () {
    corect_method_filds();
  });
})(jQuery);
